export const useIsDesktopApp = () => {
  const queryParams = new URLSearchParams(window.location.search);
  const isDesktop = queryParams.get("external") === "desktopapp";
  if (isDesktop) localStorage.setItem("isDesktopApp", `${isDesktop}`);
  return {
    isDesktop: isDesktop || localStorage.getItem("isDesktopApp"),
    token: queryParams.get("token"),
  };
};
